<template>
  <el-form-item :label="i18nt('designer.setting.multipleSelect')">
    <el-switch v-model="optionModel.multipleSelect" />
  </el-form-item>
</template>

<script>
import i18n from '@/utils/i18n'

/* eslint-disable */
export default {
  name: 'MultipleSelectEditor',
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object,
  },

}
</script>

<style scoped>

</style>
